import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightProviderChooserOpenedEventName = 'FREIGHT_PROVIDER_CHOOSER_OPENED';

export type FreightProviderChooserSource = 'freight-grid' | 'order-details' | 'booking-wizard' | 'unknown';

export const useTrackFreightProviderChooserOpened = (): ((source: FreightProviderChooserSource) => void) => {
  return useCallback((source: FreightProviderChooserSource) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightProviderChooserOpenedEventName, { env: environment, source });
  }, []);
};
